<template>
    <div class="container my-5">
        <div class="row">
            <div class="col-12 text-center">
                <h1>Limite de agendamentos alcançado.</h1>
                <p>Infelizmente o limite de agendamento para esta instituição alcançou seu limite. Confira as regras:</p>
                <ul class="text-start">
                    <li>São permitidos até 2 roteiros por dia;</li>
                    <li>Ou até 4 roteiros por mês.</li>
                </ul>
            </div>
        </div>
    </div>
</template>